export const newLinkRegex = /((?:^|[\s>]|<\/\w+>))((?:https?:\/\/|www\.)[\w.-]+\.[a-z]{2,}(?:\/\S*)?)/gi;

export const hasLink = (text: string) => {
  const regex = new RegExp(newLinkRegex);
  return regex.test(text);
};

export const formatInnerHTMLinks = (text: string) => {
  return text.replace(newLinkRegex, '$1<a href="$2" style="color: blue; text-decoration: underline;">$2</a>');
};

export const hashtagRegex = /\{hashtag\|(\\#|#)\|([^}]+)\}/g;

export const formatHashtags = (text: string) => {
  if (!text) return text;
  return text.replace(hashtagRegex, '#$2');
};

export const formatInnerHTMLHashtags = (text: string) => {
  if (!text) return text;
  return text.replace(hashtagRegex, '<span style="color: blue">#$2</span>');
};

export function renderReviewCampaignLink(slug: string) {
  return `${window.location.host}/revs/${slug}`;
}

export function getSupportUrl(countryCode: string | null): string {
  return countryCode === 'ita'
    ? 'https://www.jooice.com/it/resources/guides'
    : 'https://www.jooice.com/resources/guides';
}
